/**
 * Composer-draft stash for the SharePoint connect redirect. `beginConnect` is a
 * full-page OAuth redirect; stashing lets the composer restore a half-typed
 * message when the user lands back.
 *
 * sessionStorage, not localStorage: the stash is only meaningful for the tab
 * that left for the OAuth round trip, and it must not outlive the session.
 */

export const DRAFT_STASH_KEYS = {
  assistant: 'chat-draft-stash:assistant',
  tender: 'chat-draft-stash:tender',
  draftPanel: 'chat-draft-stash:draft-panel',
} as const

export function stashDraft(key: string, text: string): void {
  if (!text.trim()) return
  try {
    sessionStorage.setItem(key, text)
  } catch {
    // Storage full/blocked — losing the stash is acceptable.
  }
}

/** Reads and clears in one step: a restored draft must never come back twice. */
export function consumeDraftStash(key: string): string | null {
  try {
    const value = sessionStorage.getItem(key)
    if (value !== null) sessionStorage.removeItem(key)
    return value
  } catch {
    return null
  }
}
